import React from "react";

const InstallGuideSection = () => {
  const manualUrl = "/manuals/SSL_VPN_USER_MANUAL.pdf";

  return (
    <section id="guide" className="py-16 bg-shinsegae-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            설치 및 접속 가이드
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            Windows/macOS/iOS/Android 공통
          </p>
          <a
            href={manualUrl}
            className="bg-shinsegae-blue text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors inline-flex items-center"
            target="_blank"
            rel="noopener noreferrer"
            download="그룹 VPN 사용 가이드_v2.2.pdf"
          >
            <span className="inline-flex items-center justify-center w-6 h-6 mr-2 bg-white text-shinsegae-blue rounded text-sm">
              ⬇
            </span>
            설치 및 접속 가이드(PDF)
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstallGuideSection;
